import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import React, { useEffect, useRef, useState } from 'react'; 
import moment from 'moment';
import { Badge, Checkbox, Popover, Space, Tooltip, Input } from 'antd';
import './Activity.css'; 
import { UncontrolledPopover, PopoverBody } from 'reactstrap'; 
import 'antd/dist/reset.css';
import ActvityCard from '../../tabs/Activity/activity'; 
import ActivitieService from '../../common/util/ActivitieService';
import UserService from '../../common/util/UserService';
import validation from '../../common/util/validation';
import AwsServerService from '../../common/util/AwsServerService'; 
import { index } from 'mathjs';
import { ActivitySection } from '../../tabs/Task/AddTaskTabs/ActivitySection';
const { Search } = Input;
const Activities = (props) => {
let user = JSON.parse(localStorage.getItem("userinfo"));

  const [activityFilter, setActivityFilter] = useState({Sort:"DESC",SearchText:''});
  const [getActivity, setGetActivity] = useState(false)
  const [activityDealData, setactivityDealData] = useState({})
  const [selectedActivityFilter, setSelectedActivityFilter] = useState([]);
  useEffect(() => { 
    setGetActivity(true)
    AwsServerService.getAllActivityByDeal(props?.dealNames, "TASK",selectedActivityFilter, 50,activityFilter.Sort,activityFilter.SearchText)
      .then((res) => {
        setactivityDealData(res)
      })
  },[props.tasksForDeal, props.dealNames, selectedActivityFilter])
  const timeline = useRef(null);
  const [scrollBottom, setScrollBottom] = useState(0);
  useEffect(() => {
    if (timeline.current) {
      timeline.current.scrollTop = timeline.current.scrollHeight;
    }
  }, [scrollBottom]);
const handleFilterChange = (checkedValues) => {
  setSelectedActivityFilter(checkedValues);
};
const filterActivityPopOver=()=>{ 
  const filterOptions = [
    { value: 'TASK', label: 'Task' },
    { value: 'ASSIGNEE', label: 'Assignee' },
    { value: 'SUPERVISOR', label: 'Supervisor' },
    { value: 'PRIORITY', label: 'Priority' },
    { value: 'STATUS', label: 'Status' },
    { value: 'BLUEPRINT', label: 'Blueprint' },
    // { value: 'COMMENT', label: 'Comments' },
    { value: 'DEPENDENCY', label: 'Dependency' },
    { value: 'TIME TRACKER', label: 'Time Tracks' },
    { value: 'SUBTASK', label: 'Sub Task' },
  ]; 
    return (
    <div className="filter-options">
      <Checkbox.Group
        value={selectedActivityFilter}
        onChange={handleFilterChange}
      >
        <Space direction="vertical">
          {filterOptions.map(option => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );
}
  return (
   <div className="activity-content">

  <div className="header" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    {/* Search Box */}
    <Search
      placeholder="Input search text"
      allowClear={true}
      onSearch={(text) => setActivityFilter({ ...activityFilter, SearchText: text })}
      onChange={(e) => {
        if (e.currentTarget.value === '') {
          setActivityFilter({ ...activityFilter, SearchText: '' });
        }
      }}
      className="inputForActivitySearch"
      style={{ width: 200 }}
    />

    {/* Filter Icon */}
    <div
      className="task_filter_box"
      // style={{width: '35px', height: '32px', backgroundColor: 'rgb(254 254 255)',
      //   border: '1px solid #cdcdcd', display: 'flex', alignItems: 'center',
      //   justifyContent: 'center', cursor: 'pointer'
      // }}
    >
      <Popover
        content={filterActivityPopOver}
        title="Apply Filter"
        trigger="click"
        placement="bottom"
        overlayClassName="Activity-Filter"
        arrow={{ pointAtCenter: true }}
      >
        <Badge color="#1677ff" style={{ left: "1em", top: "-4px" }}
          count={selectedActivityFilter.length}
        >
          <FontAwesomeIcon style={{ color: 'rgb(124 139 173)', cursor: 'pointer' }}
            icon={faFilter}
          />
        </Badge>
      </Popover>
    </div>
  </div>

  <div className="activity-table-wrapper" style={{maxHeight:"27rem"}}>
    <div className="activity-table-container" style={{maxHeight:"27rem"}}>
      <div className="activity-cards-container" style={{padding:"10px 13px"}}>
        {getActivity && props.tasksForDeal?.map((pipeline, pipelineIndex) => (
          pipeline?.Tasks?.length > 0 && (
          <div key={`pipeline-${pipelineIndex}`} className="activity-pipeline-container">
            {pipeline.Tasks.map((taskItem, taskIndex) => {
              // Get the activities for this specific task
              return(
                <>
              <div key={`group-${index}`} className="activity-card">
                <div className="activity-card-header">
                  <h4>{taskItem.TaskName}</h4>
                  <span className="activity-pipeline" style={{ marginLeft: "10px" }}>
                    {pipeline.PipelineName}
                  </span>
                    </div>
                    <div className="activity-card-body" style={{ maxHeight: '400px', overflowY: 'auto', backgroundColor: "#edf0f4" }} ref={timeline}>
                      <ActivitySection 
                        setScrollBottom = {setScrollBottom}
                        // taskId={isSubTaskView ? taskData?.SubTaskROWID : taskItem?.TaskROWID}
                        taskId={taskItem?.TaskROWID}
                        task={taskItem} 
                        // module={(isSubTaskView && selectedTable == 'pipelines') ? "SUBTASKTEMPLATE" :
                        //     (!isSubTaskView && selectedTable == 'pipelines') ? "TASKTEMPLATE" :
                        //     (isSubTaskView && selectedTable !== 'pipelines') ? "SUBTASK" : "TASK"}
                        module={"TASK"}
                        // refreshData={refreshData}
                        // allTasksAndSubtasks={allTasksAndSubtasks}
                        // viewTaskFunction={openTaskFromActivity}
                        selectedActivityFilter={selectedActivityFilter}
                        activityFilter={activityFilter}
                        fromDeal = {true}
                        dealName = {props?.dealNames}
                        activityDealData = {activityDealData}
                      />
                    </div>
                  </div>
                </>
              )
            })}
          </div>
          )
                ))}
      </div>
    </div>
  </div>

</div>

  );
};

export default Activities;